// Detect if we're on the sales portal based on subdomain
export const isSalesPortal = (): boolean => {
  const hostname = window.location.hostname;
  return hostname.includes('sales.');
};

export const getPortalName = (): string => {
  return isSalesPortal() ? 'Sales Portal' : 'Affiliate Portal';
};

export const getPortalDescription = (): string => {
  return isSalesPortal()
    ? 'Sign in to your sales account'
    : 'Sign in to your affiliate account';
};

export const getRegisterDescription = (): string => {
  return isSalesPortal()
    ? 'Create your sales account'
    : 'Create your affiliate account';
};
